import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import TransportsTableHeader from './TransportsTableHeader';
import TransportsToolbar from './TransportsToolbar';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '../../../Utils/LinearProgress';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_BRAND, NO_TABLE_DATA_MESSAGE } from '../../../../Utils/Constants';
import TransportManagementAPI from '../../../../API/TransportManagementAPI';
import { handleServerError } from '../../../../Utils/Helper';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center',
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  editWidth: {
    width: '38px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


export class TransportsTable extends Component {
  _isMounted;
  searchTimer = null;
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_BRAND,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      reloading: false,
      openError: false,
      alertMessage: '',
    };
    this.dataAPI = new TransportManagementAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    this.reloadTable();
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  reloadTable() {
    this.setState({ reloading: true });
    this.dataAPI.getTransportsLots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.orderBy, this.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ResultList,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.dataAPI.getTransportsLots(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ResultList,
          count: response.data.NumberFilteredResults,
          order, orderBy,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.dataAPI.getTransportsLots(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ResultList,
          count: response.data.NumberFilteredResults,
          page: page,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.dataAPI.getTransportsLots(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ResultList,
          count: response.data.NumberFilteredResults,
          rowsPerPage: event.target.value,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.dataAPI.getTransportsLots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy).then((response) => {
        if (this._isMounted)
          this.setState({
            data: response.data.ResultList,
            count: response.data.NumberFilteredResults,
            search: searchBy,
            page: STARTING_TABLE_PAGE,
            reloading: false
          });
      }).catch((error) => {
        if (this._isMounted)
          this.setState({
            reloading: false,
            openError: true,
            alertMessage: handleServerError(error)
          })
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClickEdit(transportLotId) {
    this.props.handleChangeShowContent('transportsByLotEdit', transportLotId);
  };

  renderTableRecords(transportList) {
    const { classes } = this.props;

    return transportList.map(transportItem => {
      return (
        <TableRow key={transportItem.Id} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.Brand}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.Model}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.qttyWidth)} component='th' scope='row' padding='none'>
            {transportItem.Quantity}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.fDateWidth)} component='th' scope='row' padding='none'>
            {transportItem.FormalizationDate}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.LotLPPT}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.SaleChannel.join(' || ')}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.editWidth)} padding='none'>
            <Tooltip title='Editar' placement='bottom' >
              <IconButton aria-label='Edit' onClick={() => this.handleClickEdit(transportItem.Id)} className={classes.buttonSizeTbl} >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    })
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        <TransportsToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          handleChangeContent={this.props.handleChangeContent.bind(this)}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <TransportsTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

TransportsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func
};

export default TransportsTable = withStyles(styles)(TransportsTable);


// WEBPACK FOOTER //
// ./src/components/Transports/ByLot/Table/TransportsTable.js